/**
 * Returns the field value in a platform generic way.
 *
 * @param {Object | string} fieldParameter - The parameter passed through the change event function.
 * @returns {string}
 */
export function getFieldValue(fieldParameter) {
    var _a;
    return typeof fieldParameter === 'string' ? fieldParameter : (_a = fieldParameter === null || fieldParameter === void 0 ? void 0 : fieldParameter.target) === null || _a === void 0 ? void 0 : _a.value;
}
